var styles = {"unitPriceWithQuantity":"ep-pricing-module-unit-price-with-quantity-dW5pd"};

export { styles as default };
